// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1egFE","col":"styles_col__1kUyj"};